import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <p className="text-[11px] uppercase tracking-[0.24em] text-gold-dark font-bold mb-4">No charge made</p>
        <h1 className="font-heading text-purple text-4xl mb-4">Checkout cancelled</h1>
        <p className="text-lav text-[15px] mb-8">
          Nothing was charged. Whenever you're ready, your place in the founding cohort is still waiting.
        </p>
        <Link
          to="/join"
          className="inline-flex items-center gap-2 bg-purple-deep text-cream font-bold rounded-full px-8 py-4 hover:bg-purple transition-colors"
          data-testid="cancel-retry-btn"
        >
          <ArrowLeft className="w-4 h-4" /> Back to enrolment
        </Link>
      </div>
    </div>
  );
}
